import React from 'react';
import lockIcon from "../../../../../../public/assets/images/lockSolid.svg";
interface TuitionFeeFieldProps {
  title?: string;
  estimated?: string | number;
  actual?: string | number;
  reimbursable?: string | number;
  onActualChange?: (v: string) => void;
  onActualBlur?: (v: string) => void;
  className?: string;
  fieldId?: string;
  hideReimbursable?: boolean;
  disabled?: boolean;
  setShowValidError?: (show: boolean) => void;
}

const TuitionFeeField: React.FC<TuitionFeeFieldProps> = ({
  title = "Tuition Fee",
  estimated = "",
  actual = "",
  reimbursable = "",
  onActualChange,
  onActualBlur,
  className = "",
  fieldId,
  hideReimbursable = false,
  disabled = false,
  setShowValidError
}) => {
  const baseControlClass = "w-full block";
  const disabledClasses = "ds-form__disabled-field bg-gray-100 text-gray-600";
  const handleNumberKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const forbidden = ["-", "e", "E", "ArrowUp", "ArrowDown"];
    if (forbidden.includes(e.key)) e.preventDefault();
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    (e.target as HTMLInputElement).blur();
  };

  const safeBaseId = fieldId ?? title.split(' ').join('-').toLowerCase();
  // eslint-disable-next-line prefer-named-capture-group
  const estimatedId = `${safeBaseId}-estimated`;
  const actualId = `${safeBaseId}-actual`;
  const reimbId = `${safeBaseId}-reimb`;
  return (
    <div className={`flex items-center gap-4 w-full min-w-0 ${className}`}>
      <div className="shrink-0 min-w-[200px] whitespace-nowrap">
        <label className="label-ds2 font-semibold">{title}</label>
      </div>

      <div className="flex flex-1 items-start gap-3 min-w-0 flex-col">
        <div className="w-full flex items-center gap-3">
          {/* Estimated */}
          <div className="ds-form flex-1 min-w-0" data-ds-theme="vessel" data-ds-variant="input">
            <label htmlFor={estimatedId} className="mb-1!">Estimated {title.toLowerCase()}</label>
            <div className="input-with-icon">
              <input
                id={estimatedId}
                className={`${baseControlClass} ds-form__control ${disabledClasses} pr-12`}
                disabled
                type="text"
                value={String(estimated)}
              />
              <button type="button" disabled className="date-input-icon">
                <img src={lockIcon} alt="locked" />
              </button>
            </div>
          </div>

          {/* Actual */}
          <div className="ds-form flex-1 min-w-0" data-ds-theme="vessel" data-ds-variant="input">
            <label htmlFor={actualId} className="mb-1!">Actual {title.toLowerCase()}</label>
            <div className="input-with-icon">
              <input
                id={actualId}
                className={`${baseControlClass} ds-form__control ${disabled ? disabledClasses : ''}`}
                type="text"
                inputMode="decimal"
                max={99999}
                value={String(actual)}
                
                onChange={(e) => {

                  const value = e.target.value;
                        if (value !== '' && Number(value) > 99999) {
                          setShowValidError?.(true);
                        //  return;
                  }
                  else{
                    setShowValidError?.(false);
                  }
                  const decimalRegex = /^\d*\.?\d{0,2}$/;
                  if (value === '' || decimalRegex.test(value)) {
                    // Remove leading zeros from integer part, but keep decimals intact
                    let cleanValue: string;
                    if (value.includes('.')) {
                      // If it has a decimal, clean the integer part only
                      const [intPart, decimalPart] = value.split('.');
                      const cleanIntPart = intPart === '' ? '0' : String(Number.parseInt(intPart || '0', 10));
                      cleanValue = cleanIntPart + '.' + decimalPart;
                    } else {
                      // No decimal, clean the whole value
                      cleanValue = value === '' ? '' : String(Number.parseInt(value, 10));
                    }
                    onActualChange?.(cleanValue);
                
                  }
                }}
                onBlur={(e) => onActualBlur?.(e.target.value)}
                onKeyDown={handleNumberKeyDown}
                onWheel={handleWheel}
                disabled={disabled}
              />
            </div>
          </div>

          {/* Reimbursable */}
          {!hideReimbursable && (
            <div className="ds-form flex-1 min-w-0" data-ds-theme="vessel" data-ds-variant="input">
              <label htmlFor={reimbId} className="mb-1!">Reimbursable</label>
              <div className="input-with-icon">
                <input
                  id={reimbId}
                  className={`${baseControlClass} ds-form__control ${disabledClasses} pr-12`}
                  disabled
                  type="text"
                  value={String(reimbursable)}
                />
                <button type="button" disabled className="date-input-icon">
                  <img src={lockIcon} alt="locked" />
                </button>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default TuitionFeeField;